<template>
  <div class="view-landing-page d-flex vh-100">
    <div v-if="isLoading" />
    <div v-if="isLoadingFailed" />
    <div v-if="currentPage !== null && subscriptionMethod === 'Otp'" class="sections-wrapper align-self-center">
      <component
        :is="getSectionComponentName(section)"
        v-for="section in currentPage.sections"
        :key="section.id"
        :configurations="JSON.parse(section.configurations)"
        :style="{ 'z-index': section.order }"
        :page-info="currentPage"
        :template="section.template"
        :mixin="{rootAccessor}"
        :store="$store"
      />
    </div>
  </div>
</template>

<script lang="js">
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import Vuep from '@/components/vuep/index.js'
import LandingPageSectionSubscription from '@/components/LandingPageSectionSubscription'
import LandingPageSectionUnsub from '@/components/LandingPageSectionUnsub'
import LandingPageSectionWithoutSubscription from '@/components/LandingPageSectionWithoutSubscription'
import rootAccessor from '@/mixins/root-accessor'
import utility from '@/utilities/utility'

export default Vue.extend({
  name: 'LandingPage',
  components: {
    LandingPageSectionSubscription,
    LandingPageSectionUnsub,
    LandingPageSectionWithoutSubscription,
    Vuep
  },
  mixins: [rootAccessor],
  computed: {
    ...mapGetters({
      currentPage: 'landingPage/currentPage',
      isLoading: 'landingPage/isLoadingPage',
      isLoadingFailed: 'landingPage/isLoadingPageFailed',
      subscriptionMethod: 'landingPage/subscriptionMethod'
    })
  },
  watch: {
    currentPage: function () {
      if (this.currentPage !== null) {
        this.setPageTitle(this.currentPage.pageTitle === null ? '' : this.currentPage.pageTitle)
        this.addDataAttribute('data-theme', this.currentPage.theme)
      }
    }
  },
  created () {
    // Load landing page
    let pageUrl = this.$route.params.id
    let landingPageToken = this.$route.query.landingPageToken
    let clickId = utility.getQueryStringValue('clickid')
    let campaign = utility.getQueryStringValue('campaign')
    this.setTrackingInfo({ clickId: clickId, campaign: campaign })
    var payload = {
      url: pageUrl,
      landingPageToken: landingPageToken
    }
    this.loadLandingPage(payload).then(response => {
      // if (this.currentPage === null) {
      //   this.$router.push({ name: '404' })
      //   return
      // }
    })
  },
  methods: {
    ...mapActions({
      loadLandingPage: 'landingPage/loadPage',
      setTrackingInfo: 'landingPage/setTrackingInfo'
    }),
    getSectionComponentName: function (section) {
      if (section.template) {
        return 'Vuep'
      }

      switch (section.sectionTypeId) {
        case 1:
          return 'LandingPageSectionSubscription'
        case 2:
          return 'LandingPageSectionUnsub'
        case 3:
          return 'LandingPageSectionWithoutSubscription'
        default:
          return 'Vuep'
      }
    }
  }
})
</script>
